import { GameSlug } from './gameSlug';

export namespace GameID {
  export const Crash = 1n;
  export const Double = 2n;
  export const Mines = 3n;
  export const Dice = 4n;
  export const Tower = 5n;
  export const Coinflip = 6n;
  export const Limbo = 7n;
  export const Slide = 8n;
  export const Frost = 9n;
  export const CrashTrenball = 10n;
  export const Splash = 11n;
}

export type GameIDType = (typeof GameID)[keyof typeof GameID];

export namespace GameIdNamespace {
  export function getGameSlugByGameId(gameId: GameIDType): GameSlug {
    switch (gameId) {
      case GameID.Crash:
        return GameSlug.Crash;
      case GameID.Double:
        return GameSlug.Double;
      case GameID.Mines:
        return GameSlug.Mines;
      case GameID.Dice:
        return GameSlug.Dice;
      case GameID.Tower:
        return GameSlug.Tower;
      case GameID.Coinflip:
        return GameSlug.Coinflip;
      case GameID.Limbo:
        return GameSlug.Limbo;
      case GameID.Slide:
        return GameSlug.Slide;
      case GameID.Frost:
        return GameSlug.Frost;
      case GameID.CrashTrenball:
        return GameSlug.Crash_Trenball;
      case GameID.Splash:
        return GameSlug.Splash;
    }
  }

  export function getGameIdByGameSlug(pathname: string): GameIDType {
    const gameSlug = Object.values(GameSlug).find(slug =>
      pathname.includes(slug),
    );

    switch (gameSlug) {
      case GameSlug.Crash:
        return GameID.Crash;
      case GameSlug.Double:
        return GameID.Double;
      case GameSlug.Mines:
        return GameID.Mines;
      case GameSlug.Dice:
        return GameID.Dice;
      case GameSlug.Tower:
        return GameID.Tower;
      case GameSlug.Coinflip:
        return GameID.Coinflip;
      case GameSlug.Limbo:
        return GameID.Limbo;
      case GameSlug.Slide:
        return GameID.Slide;
      case GameSlug.Frost:
        return GameID.Frost;
      case GameSlug.Crash_Trenball:
        return GameID.CrashTrenball;
      case GameSlug.Splash:
        return GameID.Splash;
    }
  }
}
